const UTMIFY_PIXEL_ID = '6a34acde812f971b73927efa'

let initialized = false

declare global {
  interface Window {
    pixelId?: string
  }
}

/**
 * Injects the Utmify UTM tracking script and the Utmify Pixel script.
 * Safe to call multiple times — only initializes once.
 */
export function initUtmify() {
  if (typeof window === 'undefined' || initialized) return
  if (document.querySelector('script[data-utmify-tracking]')) return
  initialized = true

  const head = document.head || document.documentElement

  // 1. UTM tracking script
  const utm = document.createElement('script')
  utm.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
  utm.async = true
  utm.defer = true
  utm.setAttribute('data-utmify-prevent-xcod-sck', '')
  utm.setAttribute('data-utmify-prevent-subids', '')
  utm.setAttribute('data-utmify-tracking', 'true')
  head.appendChild(utm)

  // 2. Utmify Pixel script
  window.pixelId = UTMIFY_PIXEL_ID
  const pixel = document.createElement('script')
  pixel.async = true
  pixel.defer = true
  pixel.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'
  head.appendChild(pixel)
}
